import React from "react";

const RosaryIcon = ({ width = 150, height = 225, className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 300 450"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <radialGradient id="beadGrad" cx="30%" cy="30%" r="70%">
        <stop offset="0%" stopColor="#A1887F" />
        <stop offset="50%" stopColor="#795548" />
        <stop offset="100%" stopColor="#4E342E" />
      </radialGradient>

      <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FFEB3B" />
        <stop offset="50%" stopColor="#FFC107" />
        <stop offset="100%" stopColor="#FF9800" />
      </linearGradient>
    </defs>

    {/* Cruz */}
    <g transform="translate(150, 400)">
      <rect x="-7" y="-35" width="14" height="70" rx="4" fill="url(#goldGrad)" stroke="#F57F17" strokeWidth="1" />
      <rect x="-22" y="-12" width="44" height="14" rx="4" fill="url(#goldGrad)" stroke="#F57F17" strokeWidth="1" />
    </g>

    {/* Disco central */}
    <circle cx="150" cy="245" r="16" fill="url(#goldGrad)" stroke="#F57F17" strokeWidth="2" />
    <circle cx="150" cy="245" r="10" fill="none" stroke="#F9A825" strokeWidth="2" opacity="0.5" />

    {/* Cordón - Cola inferior */}
    <line x1="150" y1="261" x2="150" y2="370" stroke="#5D4037" strokeWidth="3" strokeLinecap="round" />

    {/* Cuentas - Cola inferior (3 cuentas grandes) */}
    <circle cx="150" cy="280" r="11" fill="url(#beadGrad)" stroke="#3E2723" strokeWidth="1" />
    <circle cx="150" cy="310" r="11" fill="url(#beadGrad)" stroke="#3E2723" strokeWidth="1" />
    <circle cx="150" cy="340" r="11" fill="url(#beadGrad)" stroke="#3E2723" strokeWidth="1" />

    {/* Cordón - Bucle principal */}
    <circle cx="150" cy="160" r="80" fill="none" stroke="#5D4037" strokeWidth="3" />

    {/* Cuentas - Bucle (50 cuentas pequeñas distribuidas) */}
    <g transform="translate(150, 160)">
      {/* Generamos 50 cuentas en círculo */}
      {Array.from({ length: 50 }, (_, i) => {
        const angle = (i * 360) / 50 - 90; // -90 para empezar arriba
        const radians = (angle * Math.PI) / 180;
        const x = Math.cos(radians) * 80;
        const y = Math.sin(radians) * 80;
        // Cada década (10 cuentas) tiene una cuenta ligeramente más grande (Padre Nuestro)
        const isDecadeStart = i % 10 === 0;
        const radius = isDecadeStart ? 8 : 5.5;
        return (
          <circle
            key={i}
            cx={x}
            cy={y}
            r={radius}
            fill="url(#beadGrad)"
            stroke="#3E2723"
            strokeWidth="0.5"
          />
        );
      })}
    </g>

    {/* Centro del bucle (conector) */}
    <circle cx="150" cy="80" r="6" fill="url(#goldGrad)" stroke="#F57F17" strokeWidth="1" />
  </svg>
);

export default RosaryIcon;
